
const GetProducts ={
    RUTA_API_Products: 'https://full-rest-api.onrender.com/products',
    RUTA_API_Service: 'https://full-rest-api.onrender.com/service',
    RUTA_API_Products_dev: 'https://localhost:3000/products',
    RUTA_API_Service_dev: 'localhost:3000/service',
    // RUTA_API: 'http://localhost:3000/products',
};
    
export default GetProducts;